import React, { useEffect, useRef, useState } from "react";
import "./InvoiceView.css";
import InvoiceForm from "../InvoiceForm/InvoiceForm";
import { MdDelete } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedInvoiceData } from "../../../../Reducer/SelectedInvoiceDataReducer";
import Loader from "../../../../Components/Loader/Loader";
import { InvoiceDocumentViewer } from "../../../../Components/DocumentViewer/InvoiceDocumentViewer";
import {
  GetInvoiceService,
  DeleteInvoice,
  UnmergeInvoiceService,
} from "../../../../Services/InvoiceService/InvoiceService";
import CancelBtn from "../../../../Components/CustomButtons/CancelBtn/CancelBtn";
import { resetSelectedInvoiceData } from "../../../../Reducer/SelectedInvoiceDataReducer";
import ConfirmPopup from "../../../../Components/ConfirmPopup/ConfirmPopup";
import AlertMessage from "../../../../Components/AlertMessage/AlertMessage";
import { useInvoiceActions } from "../../../../hooks/useInvoiceActions";
import { Tooltip } from "../../../../Components/CommonUI/tooltip";
import { InvoiceType } from "../../../../Types/Invoice";
import { setSelectedInvoice } from "../../../../Reducer/SelectedInvoiceReducer";
import { MdCallSplit } from "react-icons/md";

import { useSearchParams } from "react-router-dom";
import { useUnsavedChangesGuard } from "../../../../Components/StatementViewer/UnsavedChangesGuard";

interface InvoiceViewProps {
  setInvoiceView: React.Dispatch<React.SetStateAction<boolean>>;
  refreshInvoices?: any;
  allInvoices: any[];
  sortSettings: any;
  fullinvoices: any[];
  totalInvoiceCount: number;
}

const InvoiceView: React.FC<InvoiceViewProps> = ({
  setInvoiceView,
  refreshInvoices,
  sortSettings,
  fullinvoices,
  totalInvoiceCount,
}) => {
  const { makeInvoiceViewed, getInvoicesInbox } = useInvoiceActions();
  const { guardNavigation } = useUnsavedChangesGuard();
  const dispatch = useDispatch();
  const [invoiceDataSource, setInvoiceDataSource] = useState<InvoiceType[]>([]);
  const [loaderStatus, setLoaderStatus] = useState(false);
  // const [openPopup, setOpenPopup] = useState(false);
  const [allInvoices, setAllInvoices] = useState<any[]>([]);
  const [currentInvoiceIndex, setCurrentInvoiceIndex] = useState(0);
  const selectedInvoice = useSelector((state: any) => state.selectedInvoice);
  const selectedClient = useSelector((state: any) => state.selectedClient);
  const [hover, setHover] = useState(false);
  const [isPreviewActive, setIsPreviewActive] = useState(true);

  const [unmergeLoading, setUnmergeLoading] = useState(false);
  const [showUnmergeConfirm, setShowUnmergeConfirm] = useState(false);

  const prevInvoiceIdRef = useRef<any>(null);

  // --- URL-based delete popup state ---
  const [searchParams, setSearchParams] = useSearchParams();
  const openPopup = searchParams.get("deletePopup") === "true";

  const setOpenPopup = (val: boolean) => {
    const params = new URLSearchParams(searchParams);
    if (val) {
      params.set("deletePopup", "true");
    } else {
      params.delete("deletePopup");
    }
    setSearchParams(params);
  };

  const loadFullInvoice = async (id: any) => {
    if (!id) return;
    setLoaderStatus(true);
    try {
      const fullInvoice = await GetInvoiceService(id);
      if (fullInvoice) {
        setInvoiceDataSource([fullInvoice]);
        dispatch(setSelectedInvoiceData(fullInvoice));

        makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
      }
    } catch (error) {
      console.error("Error loading invoice:", error);
    } finally {
      setLoaderStatus(false);
    }
  };

  const handleRefreshInvoice = async () => {
    const invoiceId = selectedInvoice?.selectedInvoice?.id;
    if (!invoiceId) return;

    try {
      refreshInvoices();
      await loadFullInvoice(invoiceId);
    } catch (error) {
      console.error("Error refreshing invoice:", error);
    }
  };
  const handleNextInvoice = async () => {
    if (currentInvoiceIndex < allInvoices.length - 1) {
      const nextIndex = currentInvoiceIndex + 1;

      setCurrentInvoiceIndex(nextIndex);
      const nextInvoice = allInvoices[nextIndex];
      await loadFullInvoice(nextInvoice.id);
      setLoaderStatus(true);
     
      try {
        const fullInvoice = await GetInvoiceService(nextInvoice.id);
        if (fullInvoice) {
          setInvoiceDataSource([fullInvoice]);
          dispatch(setSelectedInvoiceData(fullInvoice));

          makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
        }
      } catch (error) {
        console.error("Error loading invoice:", error);
      } finally {
        setLoaderStatus(false);
      }
      dispatch(setSelectedInvoice(nextInvoice));
    }
  };
  const handlePreviousInvoice = async () => {
    if (currentInvoiceIndex > 0) {
      const prevIndex = currentInvoiceIndex - 1;
      setCurrentInvoiceIndex(prevIndex);
      const prevInvoice = allInvoices[prevIndex];

      await loadFullInvoice(prevInvoice.id);
      setLoaderStatus(true);
      try {
        const fullInvoice = await GetInvoiceService(prevInvoice.id);
        if (fullInvoice) {
          setInvoiceDataSource([fullInvoice]);
          dispatch(setSelectedInvoiceData(fullInvoice));

          makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
        }
      } catch (error) {
        console.error("Error loading invoice:", error);
      } finally {
        setLoaderStatus(false);
      }
    }
  };

  const handleNextInvoiceSafely = () => {
    guardNavigation(() => void handleNextInvoice());
  };

  const handlePreviousInvoiceSafely = () => {
    guardNavigation(() => void handlePreviousInvoice());
  };

  const handleDelete = async () => {
  const invoiceId = selectedInvoice.selectedInvoice.id;
  if (!invoiceId) return;

  try {
    await DeleteInvoice(invoiceId);
    setOpenPopup(false);
    AlertMessage({ text: "Invoice deleted successfully", type: "success" });

   
    const remaining = allInvoices.filter((inv) => inv.id !== invoiceId);
    setAllInvoices(remaining);

    if (remaining.length === 0) {
      setInvoiceView(false);
      dispatch(resetSelectedInvoiceData());
    } else {
      const nextIndex = Math.min(currentInvoiceIndex, remaining.length - 1);
      const nextInvoice = remaining[nextIndex];

      setCurrentInvoiceIndex(nextIndex);
      dispatch(setSelectedInvoice(nextInvoice));
        }
  } catch (error: any) {
    AlertMessage({
      text: error.message || "Failed to delete invoice",
      type: "error",
    });
  } finally {
    refreshInvoices();
  }
};

  const HandleCancelClick = () => {
    setInvoiceView(false);
    dispatch(resetSelectedInvoiceData());
    refreshInvoices?.();
  };

  useEffect(() => {
    setAllInvoices(fullinvoices);

    const currentId = selectedInvoice?.selectedInvoice?.id;
    const index = fullinvoices.findIndex((inv: any) => inv.id === currentId);

    if (index !== -1) {
      setCurrentInvoiceIndex(index);
    } else {
      setCurrentInvoiceIndex(0); // fallback
    }

    if (currentId && currentId !== prevInvoiceIdRef.current) {
    prevInvoiceIdRef.current = currentId;
    loadFullInvoice(currentId);
  }
  }, [fullinvoices]);

  // ─── Step 1: User clicks Unmerge button ──────────────────────────────────
  // Just shows the confirm popup — does NOT call the API yet
  const handleUnmergeClick = () => {
    setShowUnmergeConfirm(true);
  };

  // ─── Step 2: User clicks Cancel in confirm popup ──────────────────────────
  // Just close the popup, do nothing
  const handleUnmergeCancel = () => {
    setShowUnmergeConfirm(false);
  };

  // ─── Step 3: User clicks Proceed/Confirm in confirm popup ─────────────────
  // NOW call the API
  const handleUnmergeConfirm = async () => {
    const invoiceId = invoiceDataSource[0]?.invoiceId;
    if (!invoiceId) return;

    // Close the confirm popup immediately
    setShowUnmergeConfirm(false);
    setUnmergeLoading(true);

    try {
      const result = await UnmergeInvoiceService({
        mergedInvoiceId: invoiceId,
      });

      AlertMessage({
        text: `Invoice unmerged. ${result.restoredInvoiceIds.length} invoice(s) restored.`,
        type: "success",
      });

      // Close InvoiceView first
      setInvoiceView(false);

      // Reset Redux state
      dispatch(resetSelectedInvoiceData());

      // Refresh inbox — absorbed invoices reappear, merged one disappears
      // Small timeout ensures setInvoiceView(false) renders before refresh
      setTimeout(() => {
        refreshInvoices?.();
      }, 100);
    } catch (error: any) {
      AlertMessage({
        text: error?.message ?? "Failed to unmerge invoice",
        type: "error",
      });
    } finally {
      setUnmergeLoading(false);
    }
  };

  // Keyboard navigation for Next (Ctrl + K) and Previous (Ctrl + J)
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Avoid triggering inside input/textarea fields
      const target = event.target as HTMLElement;
      const isTyping =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;

      if (isTyping) return;

      // Ctrl + K → Next
      if (event.ctrlKey && event.key.toLowerCase() === "k") {
        event.preventDefault();
        if (currentInvoiceIndex < allInvoices.length - 1) {
          handleNextInvoiceSafely();
        }
      }

      // Ctrl + J → Previous
      if (event.ctrlKey && event.key.toLowerCase() === "j") {
        event.preventDefault();
        if (currentInvoiceIndex > 0) {
          handlePreviousInvoiceSafely();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    currentInvoiceIndex,
    allInvoices,
    handleNextInvoiceSafely,
    handlePreviousInvoiceSafely,
  ]);

  const isMergedInvoice = invoiceDataSource[0]?.mergeStatus === "Merged";

  return (
    <div className="invoiceView">
      <div className="invoiceView-header">
        {isMergedInvoice && (
          <div style={{ marginRight: "20px" }}>
             <Tooltip title="Unmerge back into original invoices" description="">
              <button
                onClick={handleUnmergeClick}
                disabled={unmergeLoading}
                style={{
                  backgroundColor: unmergeLoading ? "#ccc" : "var(--color-brand)",
                  color: "#fff",
                  border: "none",
                  padding: "6px 14px",
                  borderRadius: "6px",
                  cursor: unmergeLoading ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <MdCallSplit size={16} />
                {unmergeLoading ? "Unmerging..." : "Unmerge"}
              </button>
            </Tooltip>
          </div>
        )}
        <div style={{ marginRight: "20px" }}>
          <Tooltip title="Delete This Invoice" description="">
            <button
              style={{
                backgroundColor: hover ? "#f0f0f0" : "transparent",
                border: "none",
                padding: "6px",
                borderRadius: "4px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                transform: hover ? "scale(1.2)" : "scale(1)",
              }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={() => setOpenPopup(true)}
            >
              <MdDelete
                size={22}
                style={{ color: hover ? "red" : "darkred" }}
              />
            </button>
          </Tooltip>
        </div>
        <div className="invoiceView-header-pagination">
          Invoice View ({currentInvoiceIndex + 1} of {totalInvoiceCount})
        </div>

        <div style={{ display: "flex", gap: "10px", marginRight: "10px" }}>
          <Tooltip title="Previous" description="shortcut: ctrl + j">
            <button
              disabled={currentInvoiceIndex === 0}
              style={{
                backgroundColor:
                  currentInvoiceIndex === 0 ? "#cccccc" : "var(--color-brand)",
                color: "#ffffff",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "none",
                cursor: currentInvoiceIndex === 0 ? "not-allowed" : "pointer",
              }}
              onClick={handlePreviousInvoiceSafely}
            >
              Previous
            </button>
          </Tooltip>
          <Tooltip title="Next" description="shortcut: ctrl + k">
            <button
              disabled={currentInvoiceIndex === allInvoices.length - 1}
              style={{
                backgroundColor:
                  currentInvoiceIndex === allInvoices.length - 1
                    ? "#cccccc"
                    : "var(--color-brand)",
                color: "#ffffff",
                padding: "4px 8px",
                borderRadius: "4px",
                width: "70px",
                border: "none",
                cursor:
                  currentInvoiceIndex === allInvoices.length - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={handleNextInvoiceSafely}
            >
              Next
            </button>
          </Tooltip>
        </div>

        <Tooltip title="Close Invoice View" position="left">
          <div
            className="invoiceView-header-close"
            onClick={() => guardNavigation(HandleCancelClick)}
          >
            <CancelBtn style={{ color: hover ? "red" : "darkred" }} />
          </div>
        </Tooltip>
      </div>

      <div className="invoiceView-body">
        {loaderStatus ? (
          <div className="invoiceView-loader">
            <Loader />
          </div>
        ) : (
          <>
            <div className="invoiceView-body-left" onMouseEnter={() => setIsPreviewActive(true)}>
              <InvoiceDocumentViewer isPreviewActive={isPreviewActive} />
            </div>

            <div className="invoiceView-body-right" onMouseEnter={() => setIsPreviewActive(false)}>
              {false ? ( //loaderStatus
                <Loader />
              ) : (
                <InvoiceForm
                  setInvoiceView={setInvoiceView}
                  invoiceDataSource={invoiceDataSource}
                   // setLoaderStatus={setLoaderStatus}
              handleNextInvoice={handleNextInvoice}
              isLastInvoice={currentInvoiceIndex === allInvoices.length - 1}
              // onEdit={() => setIsEdited(true)}
              //refreshInvoices={refreshInvoices}
              refreshInvoices={handleRefreshInvoice}
              // onEdit={() => setIsEdited(true)}
                />
              )}
            </div>
          </>
        )}

        <ConfirmPopup
          blur
          isOpen={openPopup}
          title="Delete Invoice"
          message="Do you want to delete this invoice?"
          onConfirm={handleDelete}
          onCancel={() => setOpenPopup(false)}
        />
        {/* Unmerge confirm popup — NEW */}
        <ConfirmPopup
          blur
          isOpen={showUnmergeConfirm}
          title="Unmerge Invoice"
          message="Are you sure you want to unmerge this invoice? The original invoices will be restored."
          onConfirm={handleUnmergeConfirm}
          onCancel={handleUnmergeCancel}
        />
      </div>
    </div>
  );
};

export default InvoiceView;
